import { render, staticRenderFns } from "./PanelWithMiscPurchaseRequest.vue?vue&type=template&id=21e976bd&lang=pug&"
import script from "./PanelWithMiscPurchaseRequest.vue?vue&type=script&lang=ts&"
export * from "./PanelWithMiscPurchaseRequest.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithMiscPurchaseRequest.vue?vue&type=style&index=0&id=21e976bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports